import { Injectable } from "@angular/core";
import { formatDate } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { AcademyCourse } from "../models/academy-course";

@Injectable({
    providedIn: 'root'
  })
  export class AcademyCourseAdapter{
    constructor(private translateService:TranslateService){}   

    adapt(item:any):AcademyCourse{
      const dates = (item.sessions??[]).map((d:any) => {return {date: this.convertDate(d.date), startTime: d.startTime??'',endTime: d.endTime??'', location: d.location && d.location.name? { name: d.location.name, address: d.location.address}:null}});
      const times = this.getTimes(dates);
      return {
        id:item.id,
        firstDate:this.convertDate(item.firstDate??""),
        lastDate:this.convertDate(item.lastDate??""),
        firstTime:times.start,
        lastTime:times.end,
        dates: dates,
        name: item.courseName? item.courseName : item.name,
        description	:item.description??'',
        productUrl:this.formatUrl(item.productUrl??''),
        alreadyImported:item.alreadyImported??false,
        isNew: item.isNew??false,
        price:item.pricePerPerson	??0
      }
    }

    formatUrl(url:string){
      if (!url) return "";
      
      const hasProtocol = /^https?:\/\//i.test(url);
      return hasProtocol ? url : `https://${url}`;
    }

    getTimes(dates:any){

      if (!dates.length) return {start:'-', end:'-'}

      let minTime = dates[0].startTime;
      let maxTime = dates[0].endTime;

      dates.forEach((date:any) => {
        if (date.startTime < minTime) {
          minTime = date.startTime;
        }
        if (date.endTime > maxTime) {
          maxTime = date.endTime;
        }
      });

      return {start:minTime, end:maxTime}

    }
    
   
    convertDate(datefromDb:string){
      let dateString = datefromDb;
      const dateArray = datefromDb.split('-');

      if(dateArray.length == 3){
        dateString = formatDate(dateString, 'dd/MM/yyyy', 'nl_BE')
      }else if(dateArray.length == 2){
        const date = new Date(parseInt(dateArray[0]), parseInt(dateArray[1])-1, 1);
        const month = date.toLocaleString(this.translateService.getCurrentLang() ?? 'nl', { month: 'long' });
        dateString = month + ' ' +dateArray[0]
      }
      return dateString;
    }
  }